import { omit } from 'lodash';
import React, { memo } from 'react';
import classnames from 'classnames';

import { Icon } from 'src/components/shared';

import * as infoMessageStyles from 'src/styles/info-message.module.scss';
import { GlyphName } from './pvolveGlyphMap';

export type InfoMessageTypes = 'DEFAULT' | 'ERROR' | 'SUCCESS';

type InfoMessageType = {
    [key in InfoMessageTypes]: {
        color: string;
        icon: GlyphName;
    };
};

const TYPES: InfoMessageType = {
    DEFAULT: {
        icon: 'pv-info',
        color: 'black',
    },
    ERROR: {
        icon: 'pv-alert-circle',
        color: 'red',
    },
    SUCCESS: {
        icon: 'pv-checkmark-circle',
        color: 'mint',
    },
};

interface InfoMessageProps {
    content: string;
    type?: InfoMessageTypes;
    icon?: GlyphName;
    floatIcon?: boolean;
}

const InfoMessage: React.FC<InfoMessageProps> = ({
    content,
    icon,
    type = 'DEFAULT',
    floatIcon = false,
    ...rest
}) => {
    const iconName = icon ? icon : TYPES[type].icon;
    const color = TYPES[type].color;

    const msgClasses = classnames(
        'info-msg',
        `color-pv-${color}`,
        floatIcon ? infoMessageStyles.floatIcon : ''
    );
    const props = omit(rest, 'prompt');

    return (
        <div className={msgClasses} {...props}>
            {iconName && <Icon name={iconName} color={color} className={infoMessageStyles.icon} />}
            {floatIcon ? <p>{content}</p> : content}
        </div>
    );
};

export default memo(InfoMessage);
